import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { JustinoService } from './justino.service';
import { Constants } from '../constants/constants';
import { ControlAccesoDto } from '../dto/justino/control-acceso.dto';
import { HttpClient } from '@angular/common/http';
import { ParameterDto } from '../dto/justino/parameter.dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JustinoControlAccesoService {

  private admUrl = `${environment.justinoApiUrl}/api/`;
  private parametersUrl = `${environment.justinoApiUrl}/api/parameters`;

  constructor(private http: HttpClient) { }

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getParameterByName(parameterName: string): Observable<ParameterDto> {
    const url = `${this.parametersUrl}/name/${parameterName}`;
    return this.http.get<ParameterDto>(url, { headers: this.getHeaders() });
  }

  getControlAcceso(idUsuario: string): Observable<ControlAccesoDto> {
    return this.http.get<ControlAccesoDto>(`${this.admUrl}control-acceso/${idUsuario}`, { headers: this.getHeaders() });
  }

  // Lógica para verificar el acceso del usuario
  checkAccess(idUsuario: string): Observable<boolean> {
    return this.getParameterByName('ispublic').pipe(
      switchMap((parameter) => {
        if (parameter.Value === 'True') {
          let userIdToCheck = idUsuario;
          if (!userIdToCheck) {
            const userData = JSON.parse(
              sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
            );
            userIdToCheck = String(userData.idUsuario);  
          }
          if (userIdToCheck !== 'undefined' && userIdToCheck !== '') {
            // Llamar al servicio getControlAcceso para verificar el estado
            return this.getControlAcceso(userIdToCheck).pipe(
              map((response: ControlAccesoDto) => {
                return response.access === 'GRANTED';
              }),
              catchError((error) => {
                return of(false);
              })
            );
          }
        }
        return of(false);
      }),
      catchError((error) => {
        // En caso de error al obtener el parámetro, retornar false
        return of(false);
      })
    );
  }
}
